import React, { useState, useEffect } from "react";
import { Box, useTheme, useMediaQuery } from "@mui/material";

import AdminSidebar from "./AdminSidebar";
import AdminTopbar from "./AdminTopbar";

import { useLocation } from "react-router-dom";

import AdminLoadingOverlay from "./AdminLoadingOverlay";

const SIDEBAR_WIDTH = 260;

export default function AdminLayout({ children }) {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("md"));
    const [sidebarOpen, setSidebarOpen] = useState(false);

    const location = useLocation();
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        setLoading(true);

        const t = setTimeout(() => {
            setLoading(false);
        }, 500); // tempo do loading (UX feeling)

        return () => clearTimeout(t);
    }, [location.pathname]);

    return (
        <Box sx={{ minHeight: "100vh", background: "var(--bg)" }}>
            <AdminLoadingOverlay open={loading} />
            <AdminSidebar
                mobileOpen={sidebarOpen}
                onClose={() => setSidebarOpen(false)}
            />

            <Box
                sx={{
                    ml: { md: `${SIDEBAR_WIDTH}px` },
                    display: "flex",
                    flexDirection: "column",
                    height: "100vh",
                    overflow: "hidden",
                }}
            >
                <AdminTopbar
                    isMobile={isMobile}
                    onMenuClick={() => setSidebarOpen(true)}
                />

                <Box sx={{ flex: 1, minHeight: 0, overflowY: "auto" }}>{children}</Box>
            </Box>
        </Box>
    );
}
